import { 
  Card, 
  CardHeader, 
  CardBody, 
  Heading, 
  VStack, 
  Box, 
  Text 
} from '@chakra-ui/react';
import { TimeRangeButton } from '../TimeRangeButton';
import { parseTimestampRange } from '../../utils/audioUtils';

export interface KeyTopic {
  topic: string;
  explanation: string;
  timestamp: string;
}

interface KeyTopicsProps {
  topics: KeyTopic[];
}

export const KeyTopics = ({ topics }: KeyTopicsProps) => {
  if (!topics || topics.length === 0) return null;
  
  return (
    <Card>
      <CardHeader>
        <Heading size="md">Key Topics</Heading>
      </CardHeader>
      <CardBody>
        <VStack spacing={4} align="stretch">
          {topics.map((topic, index) => {
            // Only parse timestamp if it exists
            const timeRange = topic.timestamp ? parseTimestampRange(topic.timestamp) : { start: 0, end: 0 };
            
            return (
              <Box key={index} data-testid="key-topic-item">
                <Text fontWeight="bold">{topic.topic}</Text>
                <Text>{topic.explanation}</Text>
                {/* Only show TimeRangeButton if we have a valid timestamp */}
                {topic.timestamp && (
                  <TimeRangeButton
                    start={timeRange.start}
                    end={timeRange.end}
                    description={topic.topic}
                  />
                )}
              </Box>
            );
          })}
        </VStack>
      </CardBody>
    </Card>
  );
}; 